module.exports = __webpack_public_path__ + "img/11.e22d32c1.png";